/**
 * Finds a run's input image among its input assets, regardless of provenance.
 *
 * The source is deliberately not part of the match: the user can upload an image
 * themselves ('user_upload') or apply one produced by the AI Assistant
 * ('ai_generated'), and both are legitimate inputs. Matching on 'user_upload'
 * alone silently dropped assistant images, so reopening such a model left the
 * image input field empty.
 *
 * @param {Array<Object>|undefined} assets - Run input assets
 * @returns {Object} The matching asset, or {} when there is no input image
 */
export const getInputImageAsset = assets => (
  assets?.find(asset => asset.assetType === 'image') || {}
)
